import { useState } from 'react'
import api from '../../utils/api'
import useToastContext from '../useToastContext'
import { notificationTypes } from '../../contexts/toastContext'

const useBuildingsApi = () => {
  const addToast = useToastContext()
  const [buildingsState, setBuildingsState] = useState({
    buildings: [],
    isLoading: false,
    error: null,
  })

  const [buildingState, setBuildingState] = useState({
    building: {},
    isLoading: false,
    error: null,
  })

  const [createBuildingState, setCreateBuildingState] = useState({
    isLoading: false,
    error: null,
  })

  const [updateBuildingState, setUpdateBuildingState] = useState({
    isLoading: false,
    error: null,
  })

  const [deleteBuildingState, setDeleteBuildingState] = useState({
    isLoading: false,
    error: null,
  })

  async function getBuildings(replace = false, params) {
    try {
      setBuildingsState((currentBuildingsState) => ({
        ...currentBuildingsState,
        isLoading: true,
        error: null,
      }))
      const response = await api.get('/buildings', {
        params,
        includeToken: true,
      })
      setBuildingsState({
        buildings: replace
          ? response.data.data
          : [...buildingsState.buildings, ...response.data.data],
        isLoading: false,
        error: null,
      })
    } catch (error) {
      setBuildingsState({ buildings: null, isLoading: false, error })
    }
  }

  async function getBuilding(id) {
    try {
      setBuildingState((currentBuildingState) => ({
        ...currentBuildingState,
        isLoading: true,
        error: null,
      }))
      const response = await api.get(`/buildings/${id}`)
      setBuildingState({
        building: Object.assign(
          { ...buildingState.building },
          { ...response.data }
        ),
        isLoading: false,
        error: null,
      })
    } catch (error) {
      setBuildingState({ building: [], isLoading: false, error })
    }
  }

  async function createBuilding(building) {
    try {
      setCreateBuildingState((currentCreateBuildingState) => ({
        ...currentCreateBuildingState,
        isLoading: true,
        error: null,
      }))
      const created = await api.post('/buildings', building)
      setCreateBuildingState({
        isLoading: false,
        error: null,
      })
      setBuildingsState({
        buildings: [...buildingsState.buildings, created.data],
        isLoading: false,
        error: null,
      })
      addToast(notificationTypes.success, 'Edificio creado con exito!')
    } catch (error) {
      addToast(
        notificationTypes.error,
        `Error al crear el edificio: ${error.response.data.message}`
      )
      setCreateBuildingState({ isLoading: false, error })
    }
  }

  async function updateBuilding(building) {
    try {
      setUpdateBuildingState((currentUpdateBuildingState) => ({
        ...currentUpdateBuildingState,
        isLoading: true,
        error: null,
      }))
      await api.put(`/buildings/${building.id}`, building)
      setUpdateBuildingState({
        isLoading: false,
        error: null,
      })
      setBuildingsState({
        buildings: buildingsState.buildings.map((elem) => {
          if (elem.id === building.id) {
            return Object.assign({}, elem, building)
          }
          return elem
        }),
        isLoading: false,
        error: null,
      })
      addToast(notificationTypes.success, 'Edificio actualizado con exito!')
    } catch (error) {
      addToast(
        notificationTypes.error,
        `Error al actualizar el edificio: ${error.response.data.message}`
      )
      setUpdateBuildingState({ isLoading: false, error })
    }
  }

  async function deleteBuilding(id) {
    try {
      setDeleteBuildingState((currentDeleteBuildingState) => ({
        ...currentDeleteBuildingState,
        isLoading: true,
        error: null,
      }))
      await api.remove(`/buildings/${id}`)
      setDeleteBuildingState({
        isLoading: false,
        error: null,
      })
      setBuildingsState({
        buildings: buildingsState.buildings.filter((elem) => elem.id !== id),
        isLoading: false,
        error: null,
      })
      addToast(notificationTypes.success, 'Edificio borrado con exito!')
    } catch (error) {
      addToast(
        notificationTypes.error,
        `Error al borrar el edificio: ${error.response.data.message}`
      )
      setDeleteBuildingState({ isLoading: false, error })
    }
  }

  async function updateImages(id) {
    try {
      setUpdateBuildingState((currentCreateDoorbellState) => ({
        ...currentCreateDoorbellState,
        isLoading: true,
        error: null,
      }))
      await api.put(`/buildings/${id}/updateImages`)
      setTimeout(() => {
        setUpdateBuildingState({
          isLoading: false,
          error: null,
        })
        addToast(notificationTypes.success, 'Edificio actualizado con exito!')
      }, 3000)
    } catch (error) {
      addToast(
        notificationTypes.error,
        `Error al actualizar el edificio: ${error?.response?.data?.message}`
      )
      setUpdateBuildingState({ isLoading: false, error })
    }
  }

  const state = {
    buildingsState,
    buildingState,
  }

  const methods = {
    getBuilding,
    getBuildings,
    createBuilding,
    updateBuilding,
    deleteBuilding,
    updateImages,
  }

  return [state, methods]
}

export default useBuildingsApi
